export default __webpack_public_path__ + "static/media/logo-app.cf50eec2.svg";